import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-1 text-xs font-bold tracking-wide transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 shadow-sm hover:shadow-md",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/90 hover:scale-105 shadow-glow-primary/20",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/90 backdrop-blur-sm",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/90 hover:scale-105 shadow-glow-danger/20",
        outline: "text-foreground border-2 border-border hover:bg-secondary hover:border-primary/50",
        accent: "border-transparent bg-gradient-to-br from-accent to-accent-600 text-accent-foreground hover:scale-105 shadow-glow-accent/20",
        success: "border-transparent bg-success text-success-foreground hover:bg-success/90 hover:scale-105",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
